import Icon from '@mui/icons-material/GetApp'
import { Box, Button, Typography } from '@mui/material'
import get from 'lodash/get'
import { QRCodeCanvas } from 'qrcode.react'
import { useTranslate } from 'ra-core'
import { useCallback } from 'react'
import { useRecordContext } from 'react-admin'

import { useCommonStyles } from '../config/theme'

const OrganisationRegistrationLinkField = ({ title, source }) => {
  const record = useRecordContext()
  const commonClasses = useCommonStyles()
  const translate = useTranslate()

  const onDownloadQRCodeClick = useCallback(
    (event) => {
      var canvas = document.getElementById('qr-code-image').getElementsByTagName('canvas')[0]
      const linkEl = event.currentTarget
      linkEl.href = canvas.toDataURL()
      const name = get(record, 'name')
      linkEl.download = `${name ? name + ' - ' : ''}Registration QR Code.png`
    },
    [record],
  )

  const url = get(record, source)
  if (!url) {
    return (
      <Typography component="span" variant="body2">
        n/a
      </Typography>
    )
  }
  return (
    <>
      <Box width="100%" display="flex" flexDirection="row" mt={2}>
        <Box width="64" mr={1}>
          <QRCodeCanvas value={url} size={64} />
        </Box>
        <Box width="100%" flexDirection="column">
          <Box>
            <Button color="primary" component="a" onClickCapture={onDownloadQRCodeClick}>
              <Icon sx={{ pr: '0.25em' }} />
              {translate(title)}
            </Button>
          </Box>
          <Box mt={1} ml={1.5}>
            <Typography component="span" variant="body2">
              <Box component="a" href={url} sx={commonClasses.link} target="_blank" rel="noopener noreferrer">
                {url}
              </Box>
            </Typography>
          </Box>
        </Box>
      </Box>

      <div style={{ position: 'absolute', height: 0, width: 0, overflow: 'hidden' }}>
        <div id="qr-code-image">
          <QRCodeCanvas value={url} size={1024} />
        </div>
      </div>
    </>
  )
}

OrganisationRegistrationLinkField.defaultProps = {
  title: 'resources.organisations.downloadQrCodeImage',
  source: 'registration_link',
}

export default OrganisationRegistrationLinkField
